"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCatcher = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const react_1 = tslib_1.__importDefault(require("react"));
class ErrorCatcher extends react_1.default.Component {
    constructor(props) {
        super(props);
        if (props.message) {
            catalog_core_1.Logger.warn(this.props.message || '');
        }
        this.state = { hasError: false };
    }
    componentDidCatch(error, info) {
        this.setState({ hasError: true, error: error, info: info });
        catalog_core_1.Logger.error(`Error: ${error.toString()}, Info: ${info.toString()}`);
    }
    render() {
        // TODO: Display something on error https://tfs.tsi.lan/tfs/DefaultCollection/Tableau-Dev/_workitems?id=849134
        if (this.state.hasError) {
            return (react_1.default.createElement("div", null,
                react_1.default.createElement("div", null, this.state.error ? this.state.error.message : null),
                react_1.default.createElement("pre", null, this.state.info ? this.state.info.componentStack : null)));
        }
        return this.props.children;
    }
}
exports.ErrorCatcher = ErrorCatcher;
//# sourceMappingURL=ErrorCatcher.js.map